import { highlightText } from '~/shared/lib/highlight-text'
import { Text } from '~/shared/ui'
import type { OnshoreChangeEventProps } from '../../model'
import { EventNotes, FieldsGrid } from '../shared'

export function OnshoreChangeEvent({
  event,
  searchQuery,
}: {
  event: OnshoreChangeEventProps
  searchQuery: string
}) {
  return (
    <div className="flex flex-col gap-0.5 py-[3px]">
      <Text appearance="SUBTITLE2">{highlightText(event.title, searchQuery)}</Text>
      {event.fields ? (
        <FieldsGrid
          fields={event.fields}
          searchQuery={searchQuery}
          userRole={event.userRole}
        />
      ) : null}
      {event.notes ? (
        <EventNotes
          notes={event.notes}
          searchQuery={searchQuery}
        />
      ) : null}
    </div>
  )
}
